const NAMESPACE = 'CARRIER_GUIDE';

const CLEAR_CARRIER_GUIDE_CONTENT = `${NAMESPACE}/CLEAR_CARRIER_GUIDE_CONTENT`;
const SET_CARRIER_GUIDE_CONTENT = `${NAMESPACE}/SET_CARRIER_GUIDE_CONTENT`;

export {
    CLEAR_CARRIER_GUIDE_CONTENT,
    SET_CARRIER_GUIDE_CONTENT,
};

export default NAMESPACE;
